export default __webpack_public_path__ + "static/media/Amended_Banner_H_Underlay.1931a147.jpeg";